import { MenuItem } from './types'
import {
  Home,
  Settings,
  Users,
  HelpCircle,
  Briefcase,
  CreditCard,
  Bell,
  Volume2,
  Sliders
} from 'react-feather'
import MembershipIcon from './components/MembershipIcon'

// We will often search through the values of this object, finding the first
// match. This means more specific routes should be at the top.
// For example, '/' should be at the bottom, because it will match all routes before it
export const MENU_ITEMS: Record<string, MenuItem> = {
  stitchDashboard: { title: 'Stitch Dashboard', Icon: Sliders, path: '/stitch', id: 'stitchDashboard' },
  walletLookup: { title: 'Wallet Lookup', Icon: CreditCard, path: '/wallet-lookup', id: 'walletLookup' },
  notify: { title: 'Notify', Icon: Bell, path: '/notify', id: 'notify' },
  announcements: { title: 'Announcements', Icon: Volume2, path: '/announcements', id: 'announcements' },
  patrons: { title: 'Patrons', Icon: Users, path: '/patrons', id: 'patrons' },
  memberships: { title: 'Memberships', Icon: MembershipIcon, path: '/memberships', id: 'memberships' },
  settings: { title: 'Settings', Icon: Settings, path: '/settings', id: 'settings' },
  employees: { title: 'Employees', Icon: Briefcase, path: '/employees', id: 'employees' },
  help: { title: 'Help & Support', Icon: HelpCircle, path: '/help', id: 'help' },
  dash: { title: 'Dashboard', Icon: Home, path: '/', id: 'dash' },
}

export const SPACING = 8
